const API_BASE = process.env.REACT_APP_API_BASE || "/api";

async function request(path, opts = {}) {
  const res = await fetch(API_BASE + path, opts);
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

export async function register({
  name,
  email,
  password,
  mobile,
  gender,
  dateOfBirth,
  whatsappNumber,
}) {
  return request("/auth/register", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name,
      email,
      password,
      mobile,
      gender,
      dateOfBirth,
      whatsappNumber,
    }),
  });
}

export async function login({ identifier, password }) {
  return request("/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ identifier, password }),
  });
}

export async function googleLogin({
  accessToken,
  providerToken,
  user,
  expiresAt,
}) {
  return request("/auth/google", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      accessToken,
      providerToken,
      user,
      expiresAt,
    }),
  });
}

export async function me(token) {
  return request("/auth/me", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function updateProfile({ token, data }) {
  return request("/auth/profile", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data || {}),
  });
}

export async function changePassword({
  token,
  currentPassword,
  newPassword,
  confirmPassword,
}) {
  return request("/auth/change-password", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ currentPassword, newPassword, confirmPassword }),
  });
}

export async function createAdmin({ name, email, password, token }) {
  return request("/api/auth/create-admin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ name, email, password }),
  });
}

export async function getCreatedAdmins(token) {
  return request("/api/auth/admins/created", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function deleteAdmin(id, token) {
  return request(`/api/auth/admin/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function sendOtp({ method, identifier }) {
  const res = await fetch(API_BASE + "/auth/send-otp", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ method, identifier }),
  });
  const text = await res.text();
  let body = null;
  try {
    body = JSON.parse(text);
  } catch (e) {
    body = text;
  }
  const retryAfter = res.headers.get("retry-after");
  return {
    status: res.status,
    body,
    retryAfter: retryAfter
      ? parseInt(retryAfter, 10)
      : body && body.retryAfterSeconds
        ? body.retryAfterSeconds
        : null,
  };
}

export async function verifyOtp({ identifier, otp }) {
  return request("/auth/verify-otp", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ identifier, otp }),
  });
}
